import { render, staticRenderFns } from "./InboundList.vue?vue&type=template&id=dafd9e2e&scoped=true&"
import script from "./InboundList.vue?vue&type=script&lang=js&"
export * from "./InboundList.vue?vue&type=script&lang=js&"
import style0 from "./InboundList.vue?vue&type=style&index=0&id=dafd9e2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafd9e2e",
  null
  
)

export default component.exports